import { QueryClient } from "@tanstack/react-query";
import { createTRPCClient, httpBatchLink } from "@trpc/client";
import type { inferRouterInputs, inferRouterOutputs } from "@trpc/server";
import { createTRPCContext } from "@trpc/tanstack-react-query";
import type { AppRouter } from "solution-advisor-application-services/router";
import { API_PATHS } from "src/constants/api";
import superjson from "superjson";

export type RouterInputs = inferRouterInputs<AppRouter>;
export type RouterOutputs = inferRouterOutputs<AppRouter>;

const STALE_TIME_MS = 30_000;

/**
 * `useTRPC()` returns typed query/mutation option factories for TanStack Query:
 *
 *   const trpc = useTRPC();
 *   const { data } = useQuery(trpc.v1.solutions.list.queryOptions());
 */
export const { TRPCProvider, useTRPC, useTRPCClient } = createTRPCContext<AppRouter>();

export const createQueryClient = () =>
	new QueryClient({ defaultOptions: { queries: { staleTime: STALE_TIME_MS, retry: 1 } } });

/** Auth rides on same-origin HttpOnly cookies, so there is no token handling in the client. */
export const createTrpcClient = () =>
	createTRPCClient<AppRouter>({
		links: [
			httpBatchLink({
				url: API_PATHS.trpc,
				transformer: superjson,
				fetch: (url, init) => fetch(url, { ...init, credentials: "same-origin" })
			})
		]
	});
